import moment from "moment/moment";
import {DateFormats} from "@/scripts/Common/DateFormats";

const formatDate = (date: string | undefined, format: string) => {
  if (!date || date.length <= 0) return '';

  return moment(date).format(format);
}

const getCurrentDate = () => moment();

const getMinDateRestriction = moment().add(1, 'days').format(DateFormats.ISO8601_LONG);

export {
  formatDate,
  getCurrentDate,
  getMinDateRestriction
}
